import apiRoutes from 'src/routes/apiRoutes';
import { ShortOrganization } from 'src/types/resources/Organization';
import { Task } from 'src/types/resources/Task';
import { SingleResponse } from 'src/types/utils';
import Fetcher from 'src/utils/fetcher';

export type WeekParams = {
  payPeriodAfter: string;
  payPeriodBefore: string;
};

export type ExportParams = WeekParams & {
  // none for a week with no Engagement
  organizationId: ID | null;
};

export type ExportOrganization = Pick<ShortOrganization, 'id' | 'name'>;

export default {
  organizations(params: WeekParams): Promise<{ results: ExportOrganization[] }> {
    const url = apiRoutes.talent.timeSheetsExportOrganizationsPath();
    return Fetcher.get(url, params);
  },
  create(params: ExportParams): Promise<SingleResponse<Task>> {
    const url = apiRoutes.talent.timeSheetsExportPath();
    return Fetcher.post(url, params);
  },
};
